import { client } from '../client';
import { ICase } from './types/ICase';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const completeCase = async (case_id: number, userRole?: string): Promise<ICase> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch(`${prefix}/cases/${case_id}/complete`);

  return data;
};
